export default {
  Common: {
    inputRange: 'The input range is ',
    maxLength: 'The maximum length is ',
    maxByteNum: 'The maximum number of bytes is ',
    minLength: 'The minimum length is ',
    minByteNum: 'The minimum number of bytes is ',
    maxValue: 'The maximum number is ',
    minValue: 'The minimum number is ',
    ok: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    previous: 'Previous',
    next: 'Next',
    refresh: 'Refresh',
    adSearch: 'Advanced Search',
    export: 'Export',
    upload: 'Upload',
    all: 'All',
    save: 'Save',
    detail: 'Detail',
    information: 'Information',
    warning: 'Warning',
    success: 'Prompt',
    error: 'Error',
    day: 'Day',
    minute: 'Minute',
    neOffLine: 'the ne {0} is offline',
    tips: {
      noSelect: 'No data selected',
      onlyOneSelect: 'Only one record can be selected',
      selectOne: 'Please select a record',
      success: 'Successful operation',
      failure: 'operation failed',
      confirmTip: 'Confirm deletion of selected records?'
    }
  },
  "ej2Components": {
    "grid": {
      "EmptyRecord": "No record found. "
    },
    "pager": {
      "currentPageInfo": "Page {0}, total {1} pages ",
      "totalItemsInfo": "({0} items)",
      "firstPageTooltip": "Home",
      "lastPageTooltip": "Last",
      "nextPageTooltip": "Next",
      "previousPageTooltip": "Previous",
      "nextPagerTooltip": "Next",
      "previousPagerTooltip": "Previous",
      "pagerDropDown": "Pagesize",
      "pagerAllDropDown": "Items",
      "All": "All"
    },
    "uploader": {
      "Browse": "Browse",
      "Clear": "Clear",
      "Upload": "Upload",
      "dropFilesHint": "Delete",
      "uploadFailedMessage": "Upload failure",
      "uploadSuccessMessage": "Upload success",
      "readyToUploadMessage": "Preparing to upload",
      "removedSuccessMessage": "File deleted successfully",
      "removedFailedMessage": "File cannot be deleted.",
      "inProgress": "Download",
      "remove": "Delete",
      "cancel": "Cancel",
      "delete": "Delete File"
    },
    "dialog": {
      "close": "Close"
    },
    "chart": {
      "ZoomIn": "Zoom In",
      "ZoomOut": "Zoom Out",
      "Zoom": "Zoom",
      "Pan": "Pan",
      "Reset": "Reset"
    },
    "datepicker": {
      "placeholder": "Select date",
      "today": "Today"
    },
    "datetimepicker": {
      "placeholder": "Select date and time",
      "today": "Today"
    },
    "daterangepicker": {
      "placeholder": "Select date range",
      "startLabel": "Select start date",
      "endLabel": "Select end date",
      "applyText": "OK",
      "cancelText": "Cancel",
      "selectedDays": "Select Date",
      "days": "days",
      "customRange": "Custom Range"
    },
    "timepicker": {
      "placeholder": "Select Time"
    },
    "dropdowns": {
      "noRecordsTemplate": "No record found. ",
      "actionFailureTemplate": "Request failed."
    },
    "numerictextbox": {
      "incrementTitle": "Increase",
      "decrementTitle": "Decrease"
    }
  },
  Login: {
    title: 'CNMS',
    username: 'Username',
    password: 'Password',
    kaptcha: 'Captcha',
    login: 'Login',
    failure: 'Failure',
    license: 'License',
    uploadLicense: 'Upload license file',
    forceLoginTitle: 'Login prompt',
    updPasswdTitle: 'Change Password',
    firstLogin: 'Login for the first time, please change your password',
    pwdExpired: 'Password has expired',
    copyright: 'EULA',
    kaptchaError: 'Verification code loading error',
    footer: {
      standby: 'Technical Support: Hytera Communications Co., Ltd.',
      copyright: 'It is recommended to use Google Chrome 71 or above with a resolution of 1920 * 1080.'
    },
    copyrightInfo: {
      line1: 'IMPORTANT: Please carefully read this End User License Agreement ("Agreement") before using this software or any future update to this software. By using this software or any future update to this software, you are agreeing to be bound to terms of this Agreement. If you do not agree to any term of this Agreement, please do not use this software or any future update to this software.',
      line2: '1.1 Definitions',
      line3: 'The "Software" means the computer program and documentation accompanying this software, provided by the Hytera Communications Co., Ltd. ("Hytera"), including but not limited to: i) source codes, executable codes, interfaces; ii) relevant explanatory materials or files; iii) software updates and patches; and iv) data and database. The "use" or "using" of this Software means to access, download, install, copy or otherwise benefit from using this Software.',
      line4: '1.2 Intellectual Property Rights',
      line5: 'Hytera retains the copyright, property rights and other intellectual property rights of this Software. The Software is protected by intellectual property laws, including but not limited to copyright laws, and other applicable laws. "Hytera", "HYT" and “海能达” are the trademarks or registered trademarks of Hytera in PRC and/or other countries or areas. Hytera retains the ownership of its trademarks and product names. Hytera reserves all rights not expressly granted to you.',
      line6: 'The Software may use third-party software or technology (including the open source code and public domain code that may be used for the Software). If any third-party software or technology is adopted for the Software, Hytera will demonstrate relevant agreements or other documents in accordance with relevant laws and regulations through annexes of this Agreement, a package in a specific folder of the installation package of the Software, or open source software pages and other forms. The copyright, property rights and other intellectual property rights of any third-party’s software or technology used in the Software belong to the original developer.',
      line7: '1.3 Software License',
      line8: 'Before using this software, you should obtain the license for this software from Hytera or a third party authorized by Hytera by paying the licensing fee or any other fees. This Software shall only be used in conjunction with Hytera products or services and in the method that is expressly authorized by Hytera. Any use of the Software not for Hytera products or services, or beyond authorized method or scope is strictly prohibited. If you breach any material term of this Agreement, your right and license to use this Software under this Agreement will be automatically terminated. Hytera reserves all rights to the damages arose from the unauthorized use.',
      line9: '1.4 Restrictions on Use',
      line10: 'No modification: You shall not and you agree not to, or to enable others to, modify, translate or adapt this Software except to the extent you may be expressly permitted.',
      line11: 'No use in non-design purposes: You shall not and you agree not to, or to enable others to, install or use this Software for any non-design purposes.',
      line12: 'No reverse-engineering: You shall not and you agree not to, or to enable others to, reverse-engineer or de-compile the source codes of this Software, or discover the source code of this Software in other approaches.',
      line13: 'No distribution or transfer: You shall not and you agree not to, or to enable others to, sale, distribute, lease, rent, sublicense or assign any rights of this Software, or copy this Software.',
      line14: '1.5 Governing Law',
      line15: 'This Agreement shall be governed by and construed in accordance with laws in PRC. Any dispute or claim arising under or relating to this Agreement shall be brought exclusively in the court in Shenzhen, China. In case of infringement of Hytera’s intellectual property rights, Hytera shall take appropriate legal actions and seek appropriate legal remedies in any competent court without restriction against the infringing party.',
      line16: '1.6 Limitation of Liability',
      line17: 'THIS SOFTWARE IS PROVIDED "AS IS", HYTERA DOES NOT WARRANT THE SOFTWARE CAN OR CAN NOT FULLY MEET YOUR REQUIREMENTS. USER MANUAL, HELP FILES, INTRODUCTORY MANUAL AND SOFTWARE DOCUMENTATION ARE FOR YOUR REFERENCE ONLY AND SHALL NOT BE CONSTRUED AS ANY COMMITMENTS MADE BY HYTERA.',
      line18: 'To the maximum extent permitted by applicable law, Hytera and its suppliers shall be held harmless and compensated from any and all damages, arising out of use of or incapability of using the Software, including but not limited to profit loss, business interruption, confidentiality disclosure, data/code damage,  program error and intellectual property right infringement arose by a third party, even though Hytera has been advised of such possible damages in advance.',
      line19: 'The foregoing limitations and exclusions apply to the extent permitted by applicable laws in your jurisdiction. Some jurisdictions do not allow the limitation of liability. In such case, claims shall not be waived in accordance with consumer protection laws or other applicable laws.',
      line20: '1.7 Amendment',
      line21: 'If any provision of this Agreement is held invalid or unenforceable under applicable law, it shall not affect the validity or enforceability of the reminder of the terms of this Agreement. This Agreement may not be amended or supplemented without prior authorization of Hytera.',
      line22: '1.8 Termination',
      line23: 'This Agreement is effective until terminated. Your rights hereunder will terminate automatically without notice from Hytera if you fail to comply with any term of this Agreement. Upon termination of this Agreement, you shall immediately cease all use of the Software and destroy all copies, full or partial, of this Software.',
      line24: '1.9 Miscellaneous',
      line25: 'This Agreement shall not prejudice the legal rights of any party dealing as a consumer. As a legal agreement between you and Hytera, this Agreement shall supersede any and all prior representations, discussions, commitments, communications or publicity with regard to this Software.',
      line26: 'If you may have any question regarding this Agreement or may encounter any problem, please contact us by visiting the website at: http://www.hytera.com.'
    }
  },
  Index: {
    exit: 'Exit',
    myAccount: 'My account',
    custom: 'Personalization',
    about: 'About',
    version: 'Version',
    pwdFreq: 'Password changes too frequently, Password change intervals of not less than min {0}.',
    help: 'Help'
  },
  Alarm: {
    alarmSocket: 'Real-time Alarm',
    alarmOper: 'Alarm Handling',
    alarmManage: 'Alarm',
    currentAlarm: 'Current Alarm',
    historyAlarm: 'History Alarm',
    eventLog: 'Event Log',
    blockingRule: 'Blocking rules',
    alarmNotice: 'Alarm notification',
    alarmRedirect: 'Alarm redefinition',
    alarmID: 'Alarm ID',
    alarmName: 'Alarm name',
    alarmLevel: 'Alarm level',
    alarmType: 'Alarm type',
    alarmDec: 'Alarm description',
    equipmentType: 'Equipment type',
    equipmentName: 'Equipment name',
    neType: 'NE type',
    neName: 'NE name',
    neAlarmFDN: 'Alarm location',
    clearState: 'Clear status',
    confirmState: 'Confirmation status',
    createTime: 'Time of production',
    clearTime: 'Clear time',
    confirmTime: 'Confirm Time',
    clearUser: 'Clear people',
    confirmUser: 'Confirmer',
    remark: 'Remarks',
    messageNo: 'messageNo',
    xxdwinfo1: 'Detailed positioning information 1',
    xxdwinfo2: 'Detailed positioning information 2',
    xxkzinfo1: 'Detailed extension information 1',
    xxkzinfo2: 'Detailed extension information 2',
    xxkzinfo3: 'Detailed extension information 3',
    xxkzinfo4: 'Detailed extension information 4',
    cause: 'Alarm cause',
    eventCause: 'Event cause',
    advise: 'Repair suggestion',
    totalNumberOfAlarms: 'Total number of alarms',
    numberOfCriticalAlarms: 'Number of critical alarms',
    numberOfMajorAlarms: 'Number of major alarms',
    numberOfMinorAlarms: 'Number of minor alarms',
    numberOfWarningAlarms: 'Number of warning alarms',
    refresh: 'Refresh',
    export: 'Export',
    synchronize: 'Synchronize',
    confirm: 'Confirm',
    clear: 'Clear',
    alarmDetails: 'Alarm details',
    statistics: 'Statistics',
    shield: 'Shield',
    filter: 'Filter',
    alertSubscription: 'Alert subscription',
    automaticConfirmation: 'Automatic confirmation',
    pleaseEnterTheQueryCriteria: 'AlarmID/Alarm Name/Clear People/Confirmer',
    pleaseEnterAlmId: 'Please enter Event ID',
    eventId: 'Event ID',
    sysDescription: 'System description',
    sysType: 'System type',
    eventLevel: 'Event level',
    eventType: 'Event type',
    neEventFDN: 'Event location',
    eventDes: 'Event description',
    eventSource: 'Event source',
    brdType: 'Board type',
    cabinet: 'Cabinet number',
    frame: 'Frame number',
    slot: 'Slot number',
    subSlot: 'Sub slot number',
    advancedSearch: 'Advanced Search',
    advancedSearchSetting: 'Advanced Search - Condition Settings',
    exportSetting: 'Data export - condition setting',
    eventSubscription: 'Event subscription',
    rulename: 'Rule name',
    starttime: 'Start date',
    endtime: 'End date',
    status: 'status',
    add: 'Add',
    remove: 'Remove',
    edit: 'Edit',
    able: 'Enable',
    disable: 'Disable',
    notityform: 'Notification type',
    notityinterval: 'Notification period',
    notifyuser: 'Notify user group',
    notifytemplate: 'Notification template',
    notifystart: 'Start time',
    notifyend: 'End Time',
    notifyedit: 'Edit time',
    alarmAynchronize: 'Alarm Synchronize',
    alarmSource: 'Alarm source',
    extraInfo: 'extra information',
    additionInfo: 'Additional information',
    cancel: 'Cancel',
    close: 'close',
    filterSetting: 'Filter settings',
    confirmSetting: 'Auto confirm settings',
    confirmSettingParameter: 'The selected parameter cannot be null',
    alarm: 'Alarm',
    alarmNum: 'Total amount of alarm',
    event: 'Event',
    eventNum: 'Total amount of event',
    singleNetwork: 'Single network element',
    neSelect: 'Network element selection',
    nodeSelect: 'Node selection',
    pleaseChoose: 'please choose',
    confirmCycle: 'Confirmation cycle',
    minute: 'minute',
    hour: 'hour',
    day: 'day',
    thisDay: 'Today',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisYear: 'This year',
    notitylevel: 'Notification by level',
    notityitem: 'Notification by alarm item',
    notifytemplate1: 'Template 1',
    notifytemplate2: 'Template 2',
    byName: 'By name',
    byType: 'By type',
    redefine: 'Redefine',
    broadbandInquiry: 'Broadband inquiry',
    restoration: 'Reset',
    pleaseEnterAlarmDescription: 'Please enter an alarm description',
    addRules: 'Add rules',
    editRules: 'Edit rules',
    eventDetails: 'Event details',
    addBlockingRule: 'Add a blocking rule',
    editBlockingRule: 'Edit a blocking rule',
    notificationRuleName: 'Notification rule name',
    notificationTimeRule: 'Notification time rule',
    notifyUserGroup: 'Notify user group',
    methodToInforme: 'method to informe',
    redefineModigy: 'Redefine modification',
    no_checked: 'No data selected',
    too_many_checked: 'Currently selected multiple datas',
    startdatenull: 'Start date cannot be empty',
    enddatenull: 'End date cannot be empty',
    datevalidate: 'End date should be greater than start date',
    nenull: 'The alarm source information cannot be empty',
    alarmnull: 'Alarm information cannot be empty',
    notificationTimenull: 'Notification time period cannot be empty',
    alarmLevelnull: 'The alarm level cannot be empty',
    notificationMethodnull: 'Notification method cannot be empty',
    notifyUserNotExist: 'Notify the user group that it does not exist',
    fieldIsRequired: 'This item cannot be empty',
    maxLength: 'Text length cannot exceed ',
    notSingleQuoteOrBackslash: 'Single quotes or backslashes are not allowed',
    notInput: "Cant't input ",
    minValueIs: 'The minimum value is ',
    maxValueIs: 'The maximum value is ',
    notInteger: 'Not a valid integer',
    notValidDate: 'Not a valid date',
    success: 'Success',
    error: 'Error',
    syncSuccess: 'Successful synchronization',
    syncError: 'Sync failed',
    pleaseSelectNe: 'Please select network element node',
    pleaseSelectStartTime: 'Please select a start time',
    pleaseSelectEndTime: 'The end time must not be less than the start time',
    EndTimeLessThanStartTime: 'The end time must not be earlier than the start time.',
    enableconfirm: 'Are you sure you want to enable the selected blocking rule',
    unenableconfirm: 'Are you sure you want to disable the selected blocking rule',
    enableAlarmNoticeconfirm: 'Are you sure you want to enable the selected alert rule',
    unenableAlarmNoticeconfirm: 'Are you sure you want to disable the selected alert rule',
    alreadyModifiedSystem: 'Modified successfully for all the systems',
    modifiedSystemFailed: 'System failed to be modified',
    alarmredefned_1: 'Severity redefined',
    alarmredefned_2: 'Description redefined',
    alarmredefned_3: 'Severity redefined/Description redefined',
    alarmredefned_4: 'Suggestion redefined',
    alarmredefned_5: 'Suggestion redefined/Severity redefined',
    alarmredefned_6: 'Suggestion redefined/Description redefined',
    alarmredefned_7: 'Suggestion redefined/Description redefined/Severity redefined',
    alarmLevel_3: 'Warning',
    alarmLevel_2: 'Minor',
    alarmLevel_1: 'Major',
    alarmLevel_0: 'Critical',
    alarmType_0: 'Device',
    alarmType_1: 'Transfer',
    alarmType_2: 'Service',
    alarmConfirmStatus_0: 'unconfirmed',
    alarmConfirmStatus_1: 'confirmed',
    alarmClearStatus_0: 'uncleared',
    alarmClearStatus_1: 'cleared',
    confirmGhost: 'Are you sure you want to recover? Unable to recover after recovery',
    ghostAllSystem: 'All systems are successfully reset',
    fhostSystemFailed: 'Reset failed system',
    realTime: 'Real time',
    periodic: 'Periodic',
    alarmDeleteConfirm: 'Confirm to delete?',
  },
  MML: {
    currentNode: 'Node List',
    moTree: 'Mo Tree',
    mml: 'MML',
    searchHolder: 'Enter and search...',
    ne: 'NE',
    device: 'Device',
    cluster: 'Cluster',
    ue: 'UE',
    confirm: 'Confirm',
    cancel: 'Cancel',
    beginTime: 'Begin Time :',
    endTime: 'End Time :',
    mmlCommand: 'MML Command :',
    mmlResponse: 'MML Response :',
    operationCancelled: 'Execution failed, operation canceled.',
    noCheck: 'please select at least 1 item',
    atMost100: 'please select at most 100 items',
    single: 'Single',
    mass: 'Mass',
    execute: 'Execute',
    buildMML: 'Build MML',
    history: 'History',
    fileName: 'File Name',
    selectFile: 'Select a TXT file.',
    inputFileName: 'Enter the file name with a txt suffix.',
    selectFileButton: 'Browse',
    neType: 'NE Type',
    notNull: 'not null',
    maxBytesLength: 'max bytes is {0}',
    notValidIpv4: 'please enter the correct ipv4',
    notValidIpv6: 'please enter the correct ipv6',
    notValidTime: 'please enter the correct time',
    notValidDate: 'please enter the correct date',
    notValidInteger: 'please enter an integer',
    validRange: 'the valid range is {0}',
    dangerOperTip: 'Are you sure to continue this dangerous operation?',
    noResult: 'no result',
    deleteAll: 'delete all',
    command: 'Command',
    validateFailed: 'validate failed.',
    neOffline: 'the ne {0} is offline, MML configuartion is not available.',
    execFailed: 'execute failed.',
    equipmentName: 'Equipment Name: ',
    elementName: 'NE Name: ',
    subnetInfo: 'Subnet Info: ',
    equipmentIp: 'Equipment IP: ',
    loadingTip: 'Loading...'
  },
  MCS: {
    add: 'Add',
    del: 'Delete',
    mod: 'Modify',
    groupList: 'Group List',
    blackList: 'BlackList',
    qry: 'Query',
    export: 'Export(By Search Condition)',
    groupMember: 'Group Member',
    dataBusiness: 'Data Business',
    videoBusiness: 'Video Business',
    voiceBusiness: 'Voice Business',
    groupCall: 'Group Call',
    all: 'All',
    user: 'User',
    admin: 'Admin',
    dc: 'DC',
    mobile: 'Mobile',
    ordinaryUser: 'Ordinary User',
    highUser: 'Advanced User',
    superUser: 'Super User',
    online: 'On-line',
    offline: 'Off-line',
    working: 'Working',
    stun: 'Stun',
    kill: 'Kill',
    staticGroup: 'Static Group',
    dynamicGroup: 'Dynamic Group',
    areaGroup: 'Area Group',
    userNum: 'User Number',
    participantType: 'ParticipantType',
    userAlias: 'UserAlias',
    registerStatus: 'RegisterStatus',
    stunKillStatus: 'StunKillStatus',
    confirm: 'Confirm',
    cancle: 'Cancel',
    addUser: 'AddUser',
    modUser: 'ModUser',
    delUser: 'DelUser',
    qryGroupList: 'Query Grouplist',
    addBlackNum: 'Add Blacklist',
    manageBlackNum: 'Blacklist Management',
    superSearch: 'Advanced Search',
    chooseNe: 'Please Select the Network Element',
    onlyData: 'Only One Data can be selected',
    chooseData: 'Please Select Data',
    choosed: 'Have Chosen',
    num: 'Term',
    addConfirm: 'Confirm to add?',
    deleteConfirm: 'Confirm to delete?',
    userInfo: 'User Infomation',
    groupNum: 'Group Number',
    groupType: 'Group Type',
    groupAlias: 'Group Alias',
    groupOwner: 'Group Owner',
    messageInfo: 'Journal',
    addGroup: 'Add Group',
    modGroup: 'Mod Group',
    addGroupMember: 'Add to Group',
    groupMemberManage: 'Group Member Managerment',
    gpsGroupCallManage: 'Group Call Management',
    userPriority: 'User Priority',
    userPrivilege: 'User Privilege',
    inputLng: 'Please Enter Longitude(Deg)',
    inputLat: 'Please Enter Latitude(Deg)',
    locate: 'Locate',
    neOffLine: 'The Ne Is Not Online',
    insertNum: 'Please Enter Digits',
    rangeLat: 'Please Enter The Longitude of [-180,180]',
    rangeLng: 'Please Enter The Latitude of [-90,90]',
    openDrawMode: 'Open Drawing Mode',
    closeDrawMode: 'Close Drawing Mode',
    chooseAreaGroup: 'Non Area Group Cannot Set Call Area',
    require: 'The Item Cannot Be Empty',
    numAt63: 'Please Enter 0-63 Digits',
    charAt63: 'Please Enter 0-63 Characters',
    passwordEqual: 'Password And Confirm Password Should Be Consistent',
    numOrChar: 'Please Enter Numbes Or Englist',
    noSpecialChar: 'Special characters are not allowed',
    dcWarn: 'DC Cannot Set Transfer Number',
    refresh: 'Refresh',
    zoomIn: 'Enlarge',
    zoomOut: 'Narrow',
  },
  Track: {
    signManage: 'Signaling',
    signTrack: 'Signaling tracking',
    userTrack: 'User tracking',
    monitorTrack: 'Task monitoring',
    importTrackData: 'Signaling data import',
    NElist: 'NE list',
    resourcesList: 'Resource list',
    taskList: 'Task list',
    refreshTask: 'Refresh task',
    addTask: 'Add task',
    activationTask: 'Activation task',
    suspendTask: 'Suspend task',
    missionCompleted: 'mission completed',
    taskDeletion: 'Delete task',
    taskDetails: 'Task details',
    taskTracking: 'Task tracking',
    downloadFile: 'download file',
    pleaseEnterQuery: 'Please enter the query criteria',
    taskName: 'Task Name',
    neId: 'NE ID',
    taskStatus: 'Task status',
    creatTime: 'Creation time',
    startTime: 'Starting time',
    endTime: 'End Time',
    result: 'result',
    greate: 'Pending execution',
    tracing: 'Executing',
    createTask: 'Create task',
    confirm: 'Confirm',
    cancel: 'Cancel',
    measuringObject: 'Measuring object',
    pleaseSelectMeasuringObject: 'Please select the measuring object',
    pleaseSelectNE: 'Please select the resource',
    taskID: 'Task ID',
    trackingCommunity: 'Tracking community',
    publicMessage: 'Public message',
    internalSignaling: 'Internal signaling',
    standardInterface: 'Standard interface',
    signalingDetails: 'Signaling details',
    close: 'Close',
    search: 'Search',
    all: 'All',
    activation: 'Activation',
    complete: 'Complete',
    importFileError: 'Import file error',
    queryTrack: 'Signaling query',
    import: 'Import',
    export: 'Export',
    noDataToExport: "No data can't be exported",
    fieldIsRequired: 'This item cannot be empty',
    fileName: 'file name',
    add: 'Add',
    active: 'Active',
    stop: 'Stop',
    hangup: 'Hangup',
    finish: 'Finish',
    delete: 'Delete',
    detail: 'Detail',
    mission: 'Mission',
    download: 'Download',
    notGenerated: 'Related files not generated',
    queryError: 'Query error',
    taskInProgress: 'Task in progress',
    taskIsPending: 'Task is pending',
    missionAlreadyCompleted: 'Mission completed',
    deleteTaskInfo: 'Deleting a task will also delete the related report file. Whether to delete the task？',
    success: 'Success',
    error: 'Error',
    autoActivationFailed: 'Auto activation failed',
    searchNe: 'Enter sth to search NE',
    searchResource: 'Enter sth to search Resource',
    resourceID: 'Resource ID',
    resourceName: 'Resource Name',
    resourceType: 'Resource Type',
    endTimeGreaterThanStartTime: 'End time shoule be greater than start time',
    neName: 'neName',
    time: 'time',
    operating: 'operating',
    signalDataExport: 'Signaling data export',
    systemId: 'system ID',
    reportType: 'Report type',
    realTime: 'real time',
    file: 'file',
    taskTypeID: 'Template ID',
    taskSrc: 'Task source',
    messageType: 'Message type',
    struct: 'Structure',
    text: 'text',
    status: 'status',
    implementation: 'In progress',
    systemOutTime: 'System connection timed out',
    save: 'Save',
    issued: 'issued',
    reIssued: 'Re-issue',
    pleaseSelect: 'Please select',
    filterConditions: 'Filter conditions',
    attributeName: 'The attribute name',
    expression: 'Expression',
    attributeValues: 'Attribute values',
    filter: 'Filter',
    historyFilter: 'The history filter',
    realTimeFiltering: 'Real-time filtering',
    deleteFile: 'Whether to delete the file or not？'
  },
  Security: {
    inputRoleName: 'Please enter the role name',
    add: 'Add',
    delete: 'Delete',
    modify: 'Modify',
    active: 'Activate',
    success: 'Success',
    failure: 'Failure',
    securityManage: 'Security',
    authorityManage: 'Auth Management',
    userManage: 'Account Management',
    roleManage: 'Role Management',
    logManage: 'Log Management',
    loginLog: 'Login Log',
    operateLog: 'Operation Log',
    strategyManage: 'Strategy Management',
    userStrategy: 'User Strategy',
    pwdStrategy: 'Password Strategy',
    timeStrategy: 'Time Strategy',
    LicenseManage: 'License Management',
    device: 'Device',
    strategyNameExist: 'Strategy name already exists',
    clientRules: 'Address rules',
    User: {
      username: 'Username',
      realname: 'Real name',
      password: 'User password',
      confirmpwd: 'Confirm password',
      phone: 'Phone',
      email: 'Email',
      status: 'Status',
      start: 'Enable',
      abandon: 'Disable',
      desc: 'Description'
    },
    Role: {
      name: 'Role Name',
      createTime: 'Creation time',
      creator: 'Creator',
    },
    Strategy: {
      name: 'Strategy name',
      startDate: 'Start date',
      endDate: 'End date',
      startTime: 'Start time',
      endTime: 'End time',
      weekday: 'Week',
      date: 'Date',
      time: 'Time',
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      to: 'to',
      accountMinNumber: 'Account minimum characters',
      accountLock: 'Account Lockout Strategy',
      lockPeriod: 'Specify the time period(Minute)',
      failTimes: 'Number of consecutive login failures in a predetermined period of time',
      lockTime: 'Lock time(Minute)',
      lockOn: 'Permanently locked',
      pwdMinNumber: 'Password minimum characters',
      shortInterval: 'Minimum password change interval(Minute)',
      constitute: 'Password composition',
      onlyNumChar: 'Contains only numbers and letters',
      special: 'Contains at least one special character:!#$%&*+-/<=>?@[\\]^{_}~',
      updPwd: 'Force password change on expiration',
      pwdPeriod: 'Password validity period',
      remindDay: 'Notify password change a few days before expiration',
      updTipInfo: 'After the strategy is modified, it will take effect when the user next logs in.'
    },
    Log: {
      loginResult: 'Login results',
      loginTime: 'Log in time',
      module: 'Module',
      feature: 'Features',
      result: 'Result',
      "execType": "Execution Type",
      execTime: 'Execution time'
    },
    client: {
      startAddress: 'Start Address',
      endAddress: 'End Address',
      addClient: 'Add Rule',
      editClient: 'Edit Rule'
    },
    placeholder: {
      username: 'Please enter a username',
      realname: 'Please enter the real name',
      password: 'Please enter the user password',
      confirmpwd: 'Please enter the user password',
      mail: 'please input your email',
      phone: 'Please enter the phone',
      strategyName: 'Please enter a strategy name',
      inputInteger: 'Please enter an integer',
      startAddress: 'Please enter start address',
      endAddress: 'Please enter end address'
    },
    auth: {
      ne: 'NetElement domain',
      fun: 'Function permissions',
      search: 'NetElement search'
    },
    validate: {
      email: 'Please enter a valid email address',
      minLength: 'Please enter at least {0} characters',
      maxLength: 'Please enter less than {0} characters',
      noSpecial: 'Please enter a combination of numbers and letters',
      special: 'Please enter a combination containing at least one special character',
      phone: 'Phone Number format error',
      ip: 'IP address format error',
      addressRangeErr: 'IP address is not in the same segment address',
      addressCompareErr: 'It should be less than the end address of the start address'
    },
    Lic: {
      esn: 'ESN',
      uploadStatus: 'Upload Status',
      uploadTime: 'Upload Time',
      activeStatus: 'Active state',
      activeTime: 'Active Time',
      licenseDetail: 'License details',
      activeLicense: 'Please activate the device License',
      uploadStatus_uploaded: 'uploaded',
      uploadStatus_unupload: 'not uploaded',
      activeStatus_activated: 'activted',
      activeStatus_inactivated: 'inactivated',
      syncDevLicense_warntip : 'synchronized devices have not uploaded a license',
      activeLicense_warntip:'The device is activated and cannot be operated',
      activeLicense_warntip1:'Please upload the license first'
    },
    pwdNotMatch: 'Password and confirm password not match',
    addUser: 'Add User',
    editUser: 'Edit User',
    userInfo: 'User Info',
    authInfo: 'Authority Info',
    roleInfo: 'Role Info',
    addRole: 'Add Role',
    editRole: 'Modify Role',
    addTimePolicy: 'Add time strategy',
    editTimePolicy: 'Modify time strategy',
    selectDate: 'Select Date',
    userExist: 'User already exists',
    deleteLog: 'Before deleting database records, check the exported logs',
    exportTimeNotNull: 'Export time cannot be empty',
    roleNameNotNull: 'Role name cannot be empty',
    roleNameExists: 'Role already exists',
    selectTimePolicy: 'Please select a time strategy',
    defaultPolicyNotDel: 'Delete disabled by the default strategy',
    defaultPolicyNotEdit: 'Edit disabled by default strategy',
    dateNotNull: 'Date is not empty',
    dateCompare: 'Start date cannot be greater than end date',
    timeNotNull: 'Time is not empty',
    timeCompare: 'The start time cannot be greater than the end time',
    weekNotNull: 'Week is not empty',
    EadminCannotModify: 'Role Eadmin cannot be modified',
    EadminCannotDelete: 'Role Eadmin cannot be deleted',
  },
  Software: {
    td_neName: 'Device Type',
    td_taskType: 'Task Type',
    td_operationType: 'Operation Type',
    td_fileName: 'File Name',
    td_progress: 'Progress',
    td_status: 'Status',
    td_result: 'Result',
    td_createTime: 'Creation Time',
    td_executionTime: 'Execution Time',
    td_detail: 'Details',
    netask: 'Device Task',
    opetask: 'Operation Task',
    download: 'Push',
    active: 'Activate',
    rollback: 'Switch',
    DlandAt: 'Push;Activate',
    DlandAtandUl: 'Push;Activate;Upload',
    AtandUl: 'Activate;Upload',
    DlandUl: 'Push;Upload',
    RbandUl: 'Switch;Upload',
    upload: 'Upload',
    success: 'Succeeded',
    fail: 'Failed',
    partSucc: 'Partially succeeded',
    progressing: 'Executing',
    waitforexe: 'To be Executing',
    notstart: 'Not Started',
    done: 'Finished',
    td_packageName: 'Upgrade Package Name',
    td_packageTag: 'Package Tag',
    td_packageVer: 'Version Number',
    updataOper: 'Operation',
    filter: 'Filter',
    dataUpload: 'UpLoad',
    caution: 'The divice will restart if you select Activate. Are you sure you want to continue?',
    import: 'Import',
    export: 'Export',
    delete: 'Delete',
    refresh: 'Refresh',
    exporttemplate: 'Export Template',
    exportdata: 'Export Data',
    devicegroupname: 'Device Group Name',
    subnetmask: 'Subnet Mask',
    gateway: 'Gateway',
    startipaddr: 'Start IP Address',
    endipaddr: 'End IP Address',
    description: 'Description',
    pleaseEnterTheQueryCriteria: 'Please enter the query criteria',
    no_checked: 'No data selected',
    too_many_checked: 'Currently selected multiple datas',
    tscipautodistribute: 'eNodeB IP Automatic Allocation',
    pocupgrade: 'Poc Update',
    upgrademanage: 'Upgrade Management',
    storeversion: 'Stored Version',
    runversion: 'Running Version',
    td_neID: 'Device Name',
    td_mainPkgVer: 'Baseline Version Number',
    td_isSupportMS: 'Support Redundancy',
    td_isSupportRbk: 'Support Switch',
    td_pkgStatus: 'Pkg Status',
    query_remarks: 'Description',
    query_cabinetId: 'Shelf No',
    query_frameId: 'Chassis No',
    query_slotId: 'Slot No',
    query_appVersion: 'Application Version',
    td_taskId: 'Task ID',
    backcaution: 'The device will restart.Are you sure you want to continue?',
    vmyes: 'Yes',
    vmno: 'No',
    reserved: 'Reserved',
    running: 'Running',
    common: 'Common',
    appupdate: 'APP Software Management',
    nename: 'NE name',
    versionNo: 'Version Number',
    versionName: 'Version Name',
    uploader: 'Uploader',
    uploadtime: 'Upload time',
    notifystatus: 'Notification status',
    downloadstatus: 'Download status',
    versiondescription: 'Version description',
    MD5Code: 'MD5',
    ExecuteFile: 'Executable File',
    uploaderStr: 'Uploader',
    add: 'Add',
    close: 'Close',
    selectDeviceGrp: 'Please select a device group',
    exportTemplateTip: 'Are you sure to export window template？',
    deleteTip: 'Are you sure to delete? Unrecoverable after deletion！',
    uploadExcel: 'Upload',
    cancel: 'Cancel',
    enterKeywordSearch: 'Please enter NE name to search',
    onlyReserveAllowed: 'You can only activate the version whose version package is in the standby state',
    downloading: 'Downloading',
    downloadFailure: 'Undownloaded',
    downloadSuccess: 'Download success',
    informed: 'Notified',
    unInformed: 'No notification',
    save: 'Save',
    pleaseUploadFile: 'Please upload file',
    MD5CheckFail: 'MD5 verification failed',
    POCUpgrade: 'MPTT Upload',
    MCSUpgrade: 'MCC Upload',
    AddPOCVersion: 'Upload MPTT software package',
    AddMCSVersion: 'Upload MCC software package',
    dl_noneed: 'Not needed',
    dl_already: 'Existing',
    dl_succ: 'Download success',
    dl_fail: 'Download failure',
    pkgType: 'Package Type',
    pkgMode: 'Package Mode',
    addtask: 'Add Upgrade Task',
    redo: 'Redo',
    updManage: 'Upgrade Management',
    lte_udp_version: 'Repository Upgrade',
    softManage_Upd: 'Software/Repository upgrade',
    downloadtasklist: 'List of Download Task',
    softManage_Lib: 'Software/Repository management',
    softManage_back: 'Software/Repository switching',
    rb_version: 'Repository switching',
    que_version: 'Software/Repository query',
    queVersion: 'Querying the version',
    RequiredLength: 'The length of input data should be',
    Uploading: 'Uploading the file...',
    Searching: 'Querying...',
    deviceNotExistInfo: 'No corresponding equipment to upgrade!',
    validateInputInfo: 'The input data is wrong, check it.',
    selectOprObj: 'Select an object',
    selectOprType: 'Select operation type',
    softManage_Automantic: 'Software/Automantic base station IP allocation',
    softManage_AppUpgrade: 'Software/APP software management',
    selectAtLeastOne: 'Please select at least one piece of data!',
    dataIsLoading: 'Data is loading...',
    DHCPIsLoading: 'DHCP data is loading...',
    pleaseSelectNe: 'Please select NE firstly',
    allocated: 'Allocated',
    nonallocated: 'Unallocated',
    selectDevice: 'Select a device',
    messionExist:'An ongoing task already exists',
    queryAppSoftwareInfo: 'Querying the App information',
    serialNumber: 'Electronic Serial Number',
    ipAddress: 'IP Address',
    distributionState: 'Allocated state'
  },
  Topo: {
    devEPC: 'EPC Server',
    devhytalkPro: 'HyTalk Pro',
    devMCS: 'MCS Server',
    deveNodeB: 'eNodeB',
    deveNodeBIOPS: 'eNodeB-IOPS',
    deviBS: 'iBS',
    deviBSB: 'iBS-B',
    devODBBU: 'ODBBU',
    devgNB: 'gNB',
    devhytalk: 'HyTalk',
    addDev: 'Add Equipment',
    devID: 'Equipment ID',
    devName: 'Equipment Name',
    devType: 'Equipment Type',
    editDev: 'Modify Equipment',
    delDev: 'Delete Equipment',
    devSoftVersion: 'Software Version',
    devDescription: 'Equipment Description',
    devManager: 'Equipment Management',
    devIpPort: 'Communication IP and Port',
    devIp: 'Communication IP',
    devPort: 'Communication Port',
    devThread: 'Process Mumber',
    devSelect: 'Please select equipment type first',
    devAttriSelect: 'Please select the home equipment first',
    devAttriTrunk: 'Home Cluster',
    devAttriSubnet: 'Home Subnet',
    devCrumb: 'Topology/Resource Management/Equipment Management',
    devAdd: 'Add Equipment',
    devMange: 'Equipment Management',
    devModify: 'Modify Equipment',
    netTypeImg: 'Network Element Legend',
    physicalIP: 'Physical IP',
    physicalPort: 'Physical Port',
    serveDetail: 'Service Details',
    saveTopo: 'Save Topology',
    excelLayout: 'Table Layout',
    revertScale: 'Recovery 1:1',
    fullScreen: 'Full Screen',
    selectAll: 'Select All',
    backPrevious: 'Back to Previous',
    addNe: 'Add Network Element',
    editNe: 'Modify Network Element',
    delNe: 'Delete Network Element',
    neName: 'Network Element Name',
    neType: 'Network Element Type',
    neID: 'Network Element ID',
    neDev: 'Home Equipment',
    neManager: 'Network Element Management',
    cummunicateIPPort: 'Communication IP and Port',
    cummunicateIPPortPSelected: 'Please select IP and Port',
    neDescription: 'Network Element Description',
    neMME: 'MME',
    neHSS: 'HSS',
    nePGW: 'PGW',
    neSGW: 'SGW',
    nePCRF: 'PCRF',
    neTCF: 'TCF',
    neTMF: 'TMF',
    nePDTGW: 'PDTGW',
    neDBS: 'DBS',
    neMC_CMS: 'MC_CMS',
    neMC_CF: 'MC_CF',
    neMC_GMS: 'MC_GMS',
    neMC_IDMS: 'MC_IDMS',
    neMC_PF: 'MC_PF',
    neBM_SC: 'BM-SC',
    neMBMS_GW: 'MBMS-GW',
    neFRS: 'FRS',
    neMC_TMF: 'MC_TMF',
    nePRES: 'PRES',
    neP_HSS: 'P_HSS',
    neMC_KMS: 'MC_KMS',
    neMCE: 'MCE',
    nePCDR: 'PCDR',
    neDMS: 'DMS',
    neMC_GMS_NODE: 'MC_GMS_NODE',
    neeNodeB: 'eNodeB',
    neODBBU: 'ODBBU',
    neiBS_B: 'iBS-B',
    neCU: 'CU',
    neDU: 'DU',
    neSelect: 'Please select NE type first',
    neDevSelect: 'Please select the home cluster first',
    addTrunk: 'Add Cluster',
    trunkName: 'Cluster Name',
    trunkCode: 'Cluster Type',
    editTrunk: 'Modify Cluster',
    delTrunk: 'Delete Cluster',
    trunkManager: 'Cluster Management',
    trunkDescription: 'Cluster Description',
    neList: 'Ne List',
    trunkNelist: 'Mount Network Element',
    trunkMC_CF: 'MCS',
    trunkHyTalk: 'HyTalk',
    // trunkMC_PF: 'MC_PF',
    // trunkMC_TMF: 'MC_TMF',
    trunkSelect: 'Please select the cluster type first',
    addSubnet: 'Add Subnet',
    subnetID: 'Subnet ID',
    subnetType: 'Subnet Type',
    subnetName: 'Subnet Name',
    subnetDes: 'Subnet Description',
    subnetMan: 'Subnet Management',
    updateSubnet: 'Modify Subnet',
    deleteSubnet: 'Delete Subnet',
    parentNode: 'Parent Node',
    childNode: 'Child Node',
    ipIllegal: 'Please enter a valid IP',
    portIllegal: 'The range should be1024-65535',
    success: 'Success',
    error: 'Fail',
    sureDel: 'Are you sure you want to delete？',
    delSuccess: 'Deleted Successfully',
    pleaseSelect: 'Please select data!',
    pleaseSelectOne: 'Please select a piece of data!',
    neCrumb: 'Topology/Resource Management/Network Element Management',
    neAdd: 'Add Ne',
    neMange: 'Ne Management',
    neModify: 'Modify Ne',
    trunkCrumb: 'Topology/Resource Management/Cluster Management',
    trunkAdd: 'Add Cluster',
    trunkMange: 'Cluster Management',
    trunkModify: 'Modify Cluster',
    noData: 'No Data',
    search: 'Search',
    addSuccess: 'Added Successfully',
    modifySuccess: 'Modified Successfully',
    noSelectTrunk: 'This equipment type does not allow selection of the home cluster',
    noAttriTrunk: 'Does not belong to any cluster',
    ipPortDup: 'Duplicate IP and port',
    invalidInt: 'Please enter an integer',
    inputRangeIllegal: 'The input value must be between 1 and 65535',
    noAddMore: 'Can not add any more',
    forbidDel: 'This IP and port are not allowed to be deleted',
    subnetNumFour: 'The subnet at most 4 floors',
    emptySubnet: 'Can not create an empty subnet',
    noEmptyStart: 'Names must not start with spaces',
    permissionDenied: 'Permission denied',
    elementTree: 'Network Element Tree',
    topoManagerAndTopoMonitor: 'Topology/Topology Monitor',
    confirm: 'Confirm',
    cancel: 'Cancel',
    devBelongSubnet: 'Please select the home subnet',
    topoManager: 'Topology',
    topoRack: 'Topology Rack',
    topoLoad: 'Loading..',
    topoSearchEquipment: 'Search equipment',
    topoRerefresh: 'Refresh the list',
    equipmentList: 'Equipment List',
    invalidIPAddress: 'Invalid IP address. E.g.192.168.69.1',
    neTypeForSubnet: 'Ne Type',
    topoMaxLength: 'Text length cannot exceed ',
    nodeId: 'Node ID',
    nodeType: 'Node Type',
    nodeName: 'Node Name',
    mountNode: 'Mount Node',
    refresh: 'The topology structure has changed and the page will be refreshed.',
    pleaseEnterDeviceName:'Please enter the device name',
    pleaseEnterNeName:'Please enter the ne name',
    longitude: 'Longitude',
    latitude: 'Latitude',
    altitude: 'Altitude',
    longitudePlaceholder: 'Please enter the longitude -180~180',
    latitudePlaceholder: 'Please enter the latitude -90~90',
    altitudePlaceholder: 'Please enter the altitude -9999~9999',
    longitudeIllegal: 'The input value must be between -180 and 180',
    latitudeIllegal: 'The input value must be between -90 and 90',
    altitudeIllegal: 'The input value must be between -9999 and 9999',
    subnetFilterPlaceHolder: 'Node Type/Node Name',
    deviceSubnetTips:'Please add a subnet and assign permissions first.'
  },
  System: {
    // SystemManager
    deleteFile: 'File is being deleted...',
    uploadingFile: 'File is being uploaded...',
    zipTip: 'Incorrect version package format',
    epcOAM: 'EPC platform',
    imsOAM: 'IMS platform',
    mcsOAM: 'MCS platform',
    enodeb: 'eNodeB',
    ibs_b: 'iBS-B',
    ims_hytalk: 'IMS_HYTALK Platform',
    mcscl: 'MCSCL Platform',
    ftpAddress: 'FTP Address',
    ftpPort: 'FTP Port',
    ftpUser: 'FTP Username',
    ftpPassword: 'FTP Password',
    ftpTest: 'FTP Test',
    ftpAddressTip: 'For Example:192.168.1.1',
    ftpAddressNotNull: 'Please enter FTP Address',
    ftpPortTip: '1~65535',
    ftpPortNotNull: 'Please enter FTP Port',
    neOAM: 'OAM',
    missManager: 'Task Management',
    systemMiss: 'System Task',
    customMiss: 'Custom Task',
    missList: 'Task List',
    missLogs: 'Task Log',
    createTask: 'Create a scheduled task',
    taskFilter: 'Advanced Search',
    taskSearchKey: 'Enter Task ID or Task Name',
    delTask: 'Delete a scheduled task',
    activeTask: 'Activation',
    deactiveTask: 'Deactivation',
    editTask: 'Mod Task',
    taskId: 'Task ID',
    taskName: 'Task Name',
    isEffective: 'Is Active?',
    state: 'Current State',
    oprType: 'Operation Type',
    module: 'Module',
    startTime: 'Start Time',
    endTime: 'End Time',
    nextTime: 'Next Time',
    lastResult: 'Latest Result',
    description: 'Description',
    result: 'Results',
    reSuccess: "Success",
    reFault: "Failure",
    keyString: 'Enter Keyword',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    tip: 'Prompt',
    yes: 'Yes',
    no: 'No',
    pleaseChoose: 'Please Choose',
    isRunning: 'Being Executed',
    isReady: 'Ready',
    isInvalid: 'Past Due',
    taskPastDue: 'Task Expired',
    mmlMiss: 'MML Task',
    db: 'DB',
    systemFile: 'System File',
    config: 'Configuration',
    fm: 'Performance',
    alarm: 'Alarm',
    spectrum:'Spectrum',
    systemManager: 'System Management',
    pause: 'Suspended',
    selectOneMessage: 'Please select a piece of data',
    selectMessages: 'Please select data',
    confirmDel: 'Confirm Deletion',
    export: 'Export',
    searchC: 'Search Classification',
    timeRange: 'Date Range',
    serialNumber: 'SN',
    level: 'Level',
    runTime: 'Execution Time',
    selectTimeRange: 'Please select a time range',
    backupDays: 'Backup Days',
    backupNum: 'Backup Number',
    resultNotice: 'Send Result',
    runCycles: 'Execution Cycle',
    runCyclesTip: 'Select the execution cycle to display the form of the following block',
    every: 'Per',
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    month: 'Month',
    week: 'Week',
    weeks: 'Week',
    ri: 'Day',
    everyWeekend: 'Every Workday',
    geYueDi: 'Months',
    geWeek: 'Week',
    remarks: 'Remarks',
    selectFile: 'Select File',
    selectFileTip: 'Only .txt files can be uploaded, and no more than 1MB',
    inputTip: 'Enter the content',
    uerNameNotNull: 'Username can not be empty',
    fileNotNull: 'File can not be empty',
    timeRangeNotNull: 'The interval cannot be empty',
    dayRangeInvalid: 'The day interval range must be 1-31',
    hourRangeInvalid: 'The hour interval range must be 1-23',
    minuteRangeInvalid: 'The minute interval range must be 1-59',
    endDateInvalid: "The limit time must be greater than start time",
    sixMonth:"Six Month",
    oneYear:"One Year",
    threeYear:"Three Year",
    forever:"Persistence Save",

    // dataManager
    selectOprSet: 'Select',
    busSet: ' Business Operation',
    inputTip1: 'Enter item name, table name or creation time',
    itemName: 'Item Name',
    tableName: 'Table Name',
    updateTime: 'Update Time',
    neType: 'NE Type',
    dataTotal: 'Total(Number)',
    createTime: 'Create Time',
    editTime: 'Edit Time',
    area: 'Size On Disk(MB)',
    dataManager: 'Data Management',
    busManager: ' Business Data Management',
    resultTip: 'Result',
    backDelTime: 'Backup time or delete time can not be empty',
    backDelRange: 'Backup or delete capacity can not be empty',
    node: 'Network Element',
    resource:'Resource',
    alarmType: 'Alarm Type',
    curAlarmData: 'Current Alarm Data',
    hisAlarmData: 'Historical Alarm Data',
    busData: 'Event Data',
    runOpr: 'Operation',
    missResol: 'Process Upon Error',
    backupName: 'Backup Name',
    backupType: 'Storage Location',
    inputTip2: '1-255 English Characters',

    onlyBackup: 'Backup',
    onlyDel: 'Delete',
    backupAndDel: 'Backup And Delete',
    acTime: 'Operation By Time',
    acArea: 'Operation By Capacity',
    continueRun: 'Continue',
    stopRun: 'Terminate',
    localSave: 'Local',
    remoteSave: 'FTP Server',
    bothSave: 'Both',
    beforeDay7: '7 Days Ago',
    beforeDay15: '15 Days Ago',
    beforeDay30: '30 Days Ago',
    num1000: '1000',
    num3000: '3000',
    num5000: '5000',
    num10000: '10000',
    backupTime: 'Date Range',
    inputTip3: 'Execute the record n days ago',
    backupArea: 'Capacity Range',
    inputTip4: 'Execute the data before n items',
    delTime: 'Date Range',
    delArea: 'Capacity Range',
    inputTip5: 'Delete records n days ago',
    inputTip6: 'Delete the data before n items',
    oprTime: 'Date Range',
    oprArea: 'Capacity Range',

    addPkg: 'Add Version Package',
    add: 'Add',
    delete: 'Delete',
    inputTip7: 'Enter keywords to search',
    productType: 'Product Model',
    productEle: 'Subordinate network element and platform',
    productVersion: 'Product Version',
    changeTime: 'Update Time',
    upFileTip: 'You can only upload zip files not larger than 500M',
    delPkgTip: 'Are you sure you want to delete these packages?',
    pkgManager: 'Package Management',
    uploadFile: 'Upload',
    selectDelObj: 'Please select delete object',
    addPkgObj: 'Please add an adapter package',
    mailTip: 'Tip: Set the docking parameters between the system and the mailbox server to establish communication between them. When the email notification function is enabled, the system will automatically send email to notify users. In order to ensure the security of sending e-mail, SSL/TLS(Secure Sockets Layer) secure connection is recommended',
    inputTipIp: 'Please enter IP',
    mailAccount: 'Please enter mail account',
    smtpTip: 'SMTP Server Domain/IP',
    inputTipEmail: 'Please enter the correct email address',
    sslTlsTip: 'SMTP server requests SSL / TLS secure connection (please confirm that SSL / TLS certificate of mailbox server has been installed)',
    inputTipPort: 'Please enter the port number',
    port: 'Port',
    smtpCheckTip: 'Authentication',
    userCheck: 'Username',
    passwordCheck: 'Password',
    reset: 'Reset',
    testLoading: 'Testing if the server is connected...',
    test: 'Test',
    apply: 'Apply',
    systemNotice: 'System Notification',
    serviceSet: 'Server Settings',
    invalidIp: 'Invalid IP Address',
    emailNotNull: 'Please enter mail',
    inputNumber: 'Please enter number',
    inputInteger: 'Enter an integer',
    sendEmailTime: 'Email Delivery Time',
    sendResult: 'Result',
    emailTitle: 'Email Header',
    timeTaskId: 'Timed Task ID',
    emailQuery: 'Mail Inquiry',
    addressBook: 'Address Book',
    user: 'User',
    uGroup: 'User Group',
    groupExists: 'Group already exist',
    userExists: 'User already exist',
    createUserInfo: 'Create User Information',
    editUserInfo: 'Edit User Information',
    change: 'Modify',
    fGroup: 'Group',
    telephone: 'Mobile',
    email: 'Email Address',
    createGroupInfo: 'Create User Group Information',
    userGroupName: 'User Group Name',
    remoteTip: 'Remote notification needs to set the corresponding remote user group. You can add, modify, delete users.',
    inputUser: 'Enter user name',
    optionalUser: 'Optional User',
    selectedUser: 'Selected User',
    userGroupNotNull: 'User group name can not be null or empty',
    telephoneOrEmail: 'Please enter at least one of email and phone number.',
    systemName: 'Name',
    save: 'Save',
    systemLogo: 'Logo',
    pngTip: 'Only upload png files, and no more than 2MB, size is 83x35 pixel.(Recommend image background be transparent)',
    systemSet: 'System Settings',
    personal: 'Personal',
    loginAgain: 'Please login again',
    uploadSuccess: 'Upload Success',
    uploadFault: 'Upload Failed',
    rowDataNum: 'Row Data Number(Row)',
    dataLength: 'Data Length(M)',
    indexLength: 'Index Length(M)',
    tableCreateTime: 'Table Creation Time',
    tableUncode: 'Character Check Code Set Of Table',
    oprName: 'Operation Name',
    dataNameOrFtpPath: 'Data Name Or Path',
    takeTime: 'Time Taken',
    takeTimeWithUnit: 'Time Taken(Second)',
    maxLayer: 'Max Zoom',
    minLayer: 'Min Zoom',
    defaultLayer: 'Default Zoom',
    centerLon: 'Center Longitude',
    centerLat: 'Center Latitude',
    copyright: 'Prefix',
    input1t15: 'Number Between 1 And 15',
    centerLonInput: 'Longitude Of Map Center',
    centerLatInput: 'Latitude Of Map Center',
    copyrightInput: 'Prefix Of Map',
    mapConfig: 'Map Config',
    mapLngLimit: 'Please enter valid longitude, in range [-180, 180]',
    mapLatLimit: 'Please enter valid latitude, in range [-90, 90]',
    detailLog: 'Detail Of Log',
    saveMapSuccess: 'Save Success',
    // personal
    uploadConfirm: 'Confirm upload or not?',
    uploadImgWith: '83',
    uploadImgHeight: '35',
    uploadTipsWidth: 'Upload image width can not greater than 83 pixel',
    uploadTipsHeight: 'Upload image height can not greater than 35 pixel',
    uploadTipsSize: 'Upload image can not greater than 2MB',
    loading: 'Loading ...',
    processing: 'Processing ...',
    CPUUsage: "CPU Usage (%)",
    MemoryUsage: "Memory Usage (%)",
    DiskUsage: "Disk Usage (%)",
    ThresholdConfig: "Configure Resource Threshold"
  },
  Pm: {
    taskList: 'task list',
    pmManagement: 'Performance',
    cycleMeasurement: 'Cycle Measurement',
    realTimeMeasurement: 'Period Measurement',
    noRealTaskManagement: 'No Realtime Task Management',
    noRealDataQuery: 'Real-time Measurement',
    performanceIndicatorManage: 'Performance Indicator Management',
    kpiChartShow: 'KPI Chart Display',
    homePage: 'Home',
    measurementObject: 'Measurement Object',
    ne: 'NE',
    measureTaskManagement: 'Measure Task Management',
    taskID: 'Task ID',
    taskName: 'Task Name',
    measureCycle: 'Measurement Period',
    taskDescription: 'Task Description',
    uniformityState: 'Consistency Status',
    taskState: 'Task Status',
    timeMode: 'Time Model',
    start_time: 'Start Time',
    end_time: 'End Time',
    syncTime: 'Synchronization Time',
    hangUpStartTime: 'Suspended Form',
    hangUpEndTime: 'Suspended To',
    editor: 'Editor',
    editTime: 'Edit Time',
    establishTask: 'Create Task',
    hangUpTask: 'Suspend',
    delTask: 'Delete',
    modifyTask: 'Modify',
    activeTask: 'Active',
    checkUniformity: 'Check Consistency',
    synchronousDownload: 'Synchronize Task',
    dataMining: 'Replenish Data',
    integrityCheck: 'Check Data Integrity',
    queryDetailInfo: 'Detail',
    inputSearhString: 'Task Name',
    searchNe: 'Enter sth to search NE',
    measureTask: 'Measurement Object',
    ip: 'IP',
    consistentState: 'Consistent state',
    samplingPeriod: 'Measurement Period',
    samplingPeriod_unit: 'Measurement Period(s)',
    taskDuration: 'Task Length',
    taskEstablishTime: 'Creation Time',
    samplingStartTime: 'Start Time',
    pauseTime: 'Pause Time',
    uniformityCheckTime: 'Check Time',
    createTaskUser: 'Creator',
    taskTimeRemaining: 'Remaining Time',
    startUp: 'Start',
    hangup: 'Hung up',
    pause: 'Pause',
    export: 'Export',
    queryInfo: 'Query',
    indicator: 'Select Indicator',
    measuringPosition: 'Select Measurement Position',
    saveDataOrNot: 'Save Data',

    searchByNe: 'Search By NE Name',
    searchByName: 'Search By Name',
    calculator: 'Counter',
    system: 'System ',
    custom: 'Custom ',
    name: 'Indicator Name',
    unit: 'Indicator Unit',
    mode: 'Standard',
    invalidTime: 'Indicator Expiry',
    real: 'Real Time',
    nonReal: 'Non-real Time',
    realOrNo: 'Real Time/Non-real Time',
    indicatorID: 'Indicator ID',
    indicatorState: 'Indicator Status',
    indicatorFormulaColumn: 'Indicator Formula',
    indicatorFormulaText: 'Indicator Formula',
    description: 'Description',
    dataType: 'Data Type',
    neType: 'NE Type',
    measurementObjectClassify: 'Measurement Object Type',
    doubleClickChoose: 'Select indicator by double click',
    switch: 'SW', // trasform
    search: 'Search',
    revoke: 'REVK',
    clear: 'CLR',
    determine: 'OK',
    confirm: 'Confirm',
    cancel: 'Cancel',
    finish: 'Finish',
    active: 'Activated',
    inactive: 'Unactivated',
    times: 'times',
    number: 'number',
    dbm: 'dbm',
    kilobit: 'kilobit',
    ms: 'ms',
    kbps: 'kbps',
    seconds: 'seconds',
    del: 'Delete',
    add: 'Add',
    modify: 'Modify',
    alertRequired: 'This field is required',
    alertFormula1: 'Indicator formula is required', // There are no counters in the formula
    alertFormula2: 'There are no counters in the formula',
    alertFormula3: 'The counters in the formula do not match measurement object',
    alertFormula4: 'The length of formula over 256',
    alertInvalidTime: 'In the active status, the indicator expiry time cannot be earlier than the current time',
    alertData1: 'Please select a row of data',
    alertInvalidDate: 'Please enter a valid date',
    notInputSpace: 'Cannot input space',
    alertIsNumberHeader: 'Cannot start with a number or a space',
    alertMaxLength: 'Text length cannot exceed',
    toastHeader: 'Tip',
    query: 'Confirm',
    alertHeader: 'Warning',
    successInfo: 'Success',
    createTask: 'Create/Modify Task',
    first: 'The first step',
    second: 'The second step',
    preStep: 'Previous',
    nextStep: 'Next',
    indicatorList: 'List Of Indicators',
    pleaseInput: 'Please input',
    queryWillDel: 'Are you sure you want to delete',
    cellMeasure: 'Cell Measurement',
    quickExport: 'Quick Export',
    batchExport: 'Batch Export',
    oneMinute: 'one minute',
    fiveMinutes: 'five minutes',
    tenMinutes: 'ten minutes',
    fifteenMinutes: 'fifteen minutes',
    twentyMinutes: 'twenty minutes',
    thirtyMinutes: 'thirty minutes',
    oneHour: '1 Hour',
    oneDay: '1 day',
    selectNe: 'Select NE',
    selectIndicator: 'Select Indicator',
    today: 'Today',
    yesterday: 'Yesterday',
    currentWeek: 'This Week',
    lastWeek: 'Last Week',
    specified: 'Custom',
    latest: 'Newest',
    queryScope: 'Query Criteria',
    dataLatest: 'Latest data',
    neLatest: 'Latest data of all selected Nes',
    sortMethod: 'Sort by',
    ascending: 'Ascending',
    descending: 'Dscending',
    begTimeNull: 'Start time cannot be empty',
    endTimeNull: 'End time cannot be empty',
    begTimeFormatError: 'Wrong start time format',
    endTimeFormatError: 'Wrong end time format',
    ne_name: 'Resource Name',
    measureObjName: 'Measurement Object Name',
    periodTime: 'Short Term',
    longTime: 'Long Term',
    taskNameNull: 'Task name cannot be empty',
    taskDespOver256: 'Task description cannot be greater than 256 characters',
    taskNameOver60: 'Task name cannot be greater than 60 characters',
    onlyNumAndLetter: 'Only numbers and letters are allowed',
    addToFollow: 'Add lower side',
    timeRange: 'Time Range',
    selectNePlease: 'Please select the appropriate network element',
    kpiChartEdit: 'KPI Chart Configuration',
    exportChart: 'Export Image',
    ne_id: 'Resource ID',
    chooseObject: 'Measurement Object Name',
    chooseCycle: 'Select measurement period',
    selectedKpiPath: 'Selected KPI Path',
    alarmKpi9: 'Can only show no more than 9 KPI',
    atMostOneRealTask: 'Only one real-time task can be created at most and only one task tab can be opened at a time.',
    notCloseHome: 'Do not close homepage!',
    exitTaskInfo: 'Existing Task Information',
    atLeastOne: 'Please select at least one record',
    failedToStart: 'Failed to start task',
    failedToCreate: 'Failed to create task',
    waitCommandFinish: 'Please wait for the command to finish',
    deleteSuccessfully: 'Delete success',
    deleteFailed: 'Delete failed',
    taskInProgress: 'Task in progress...',
    consistent: 'consistent',
    inconsistent: 'inconsistent',
    yes: 'Yes',
    no: 'No',
    fillCorrectTaskDuration: 'Please fill in the correct task duration!',
    selectMOplease: 'Please select the measurement object!',
    selectIndicatorPlease: 'Please select indicator!',
    selectMSeatPlease: 'Please select the measuring position!',
    fillInSamplingPeriod: 'Please fill in the sampling period!',
    reportTime: 'report time',
    processCode: 'process code',
    assocId: 'assoc id',
    dataCollection: 'data Collection',
    all: 'all',
    realTimeByIndicator: 'Real-time measurement task(by indicators)',
    realTimeBySeat: 'Real-time measurement task(by seats)',
    byIndicator: 'by indicators',
    bySeat: 'by seats',
    performTask: 'perform task',
    selectDataPlease: 'Please select data!',
    startNoLagerThanEnd: 'Start time no later than end time!',
    endNoEarilerThanCurrent: 'End time no earlier than current time!',
    pleaseSelectNe: 'Please select ne!',
    neOffline: 'The ne is offline!',
    taskAlreadyExists: 'Task already exists!',
    failure: 'failure',
    statistic_cycle: 'Statistic Cycle(s)',
    Intodb_time: 'IntoDB Time',
    data_bilievable: 'Data Integrity',
    ne_type_id: 'Resource Type',
    cabinet: 'Cabinet Number',
    frame: 'Frame Number',
    slot: 'Slot Number',
    cell_id: 'Cell ID',
    enodeb_id: 'Enodeb ID',
    realtime_task_createTask: 'Create Real-time Measurement Task',
    taskDuration_unit: 'Task Length(s)',
    taskTimeRemaining_unit: 'Remaining Time(s)',
    info: 'information',
    hasSameTaskName: 'Task with the same name already exists!',
    hasSameIndicatorName: 'Index with the same name already exists!',
    indicatorName: 'Indicator Name',
    indicatorDesc: 'Description',
    task_started: 'pm.currenttime.task.task_started',
    task_opened: 'Please close other windows before creating a new task',
    resource: 'Resource',
    resource_name: 'Resource Name',
    resourceType: 'Resource Type',
    selectResource: 'Select Resource',
    selectResourcePlease: 'Please select the source',
    resourceOffline: 'The resource is offline!',
    pleaseSelectResource: 'Please select resource!'
  },
  SubscriberIms: {
    groupTemplate: 'Group template',
    userTemplate: 'Account template',
    insertName: 'Please enter a name',
    insertStaffName: 'Please enter a staff name',
    clusterUserCreate: 'User account opening',
    clusterGroupCreate: 'User group opening',
    nelist: 'Ne List',
    neList: 'Ne List',
    userManagement: 'IMS User Management',
    organization: 'Organization',
    menuTitle: 'Subscriber/IMS Management/Group Management',
    menuTitleGroupMcs: 'Subscriber/MCS Management/Group Management',
    menuTitleUser: 'Subscriber/IMS Management/Subscriber Management',
    menuTitleUserMcs: 'Subscriber/MCS Management/Subscriber Management',
    addSiblingNode: 'Add Sibling Node',
    addChildNode: 'Add Child Node',
    modifyNode: 'Mod Node',
    add: 'Add',
    del: 'Delete',
    mod: 'Modify',
    import: 'Import',
    export: 'Export(By Search Condition)',
    addUser: 'Add User',
    batchAddUser: 'Batch Add User',
    modUser: 'Mod User',
    batchModUser: 'Batch Mod User',
    deleteUser: 'Delete User',
    addUserMember: 'Add Group Member',
    qryUserMember: 'Query Group Member',
    addGroupMember: 'Add to Group',
    qryGroupMember: 'Query Home Group',
    delUserMember: 'Delete User Member',
    modUserMember: 'Mod User Member',
    addGroup: 'Add Group',
    modGroup: 'Mod Group',
    batchAddGroup: 'Batch Add Group',
    batchModGroup: 'Batch Mod Group',
    fresh: 'Refresh',
    find: 'Query',
    warn: 'Warning',
    reminder: 'Reminder',
    logTitle: 'Log',
    confirm: 'Confirm',
    cancel: 'Cancel',
    close: 'Close',
    deleteConfirm: 'Are you sure you want to delete this data?',
    chooseNodeTip: 'Please choose one vpn node',
    notChooseRootTip: 'Can not choose the root node to add sibling node',
    notModRootTip: 'Can not modify the root node',
    notDelRootNode: 'Can not delete the root node',
    preDelChildNode: 'Please first delete the node children',
    nodesCountTip: 'At most 6 floors',
    requestResTip: 'Request falied',
    info: 'Info',
    search: 'Search',
    template: 'Template',
    subInfoDiv: 'Subscriber Equipment',
    impuinfoDiv: 'Subscriber Information',
    templateinfDiv: 'Template Information',
    serviceProfileInfoDiv: 'Service Profile',
    supplementaryInfoDiv: 'Subscriber Addition Information',
    groupProfileInfoDiv: 'Group Profile',
    tgrpserviceDiv: 'Group Service',
    tgrpadditionalDiv: 'Group Supplementary Information',
    lte_ems_subscriber_groupMatchError:'Group num is not matched with group identify num.',
    lte_hss_group_groupIdentityCompare: 'Starting number can not greater than ending number.',
    checkZoneTip: 'Please check zoneNo',
    noZoneDial1Tip: '900~999',
    noZoneDial4Tip: '00000~99999',
    noZoneDial6Tip: '000~999',
    numDialTip1: '100~109',
    numDialTip2: '00000~99999',
    numDialTip3: '00001~32767',
    numDialTip4: '00001~29999,30019~32767',
    numDialTip5: '100~109',
    numDialTip6: '200~899',
    numDialTip7: '00001~99999',
    numDialTip8: '200~899',
    numDialTip9: '200~549',
    zoneTip: 'Zone number should between 328~806',
    numTip: 'Number should between 00001~29999 or 30019~32767',
    DMRZoneTip: 'DMR requires zone number be 2 numbers',
    solid_3: '3 numbers are allowed',
    solid_5: '5 numbers are allowed',
    toomuchUsers: 'The number of users cannot exceed 1000',
    batchAddUserTip: 'Batch add users',
    batchModUserTip: 'Batch modify',
    waitTip: 'Please wait......',
    qryVpnFailTip: 'Query vpn failed',
    selectVButton: 'Select',
    qryDialPlanFailTip: 'Query dailplan failed',
    notSuppoDialTip: 'NM do not support this dialplan',
    chooseUserDataTip: 'Please check user data',
    chooseGroupDataTip: 'Please check group data',
    notAddDynamicsTip: 'Can not add to dynamics group',
    notAddNetgate: 'Netgate users cannot be added to group',
    passwordEqual: 'Password And Confirm Password Should Be Consistent',
    userNo: 'User No.',
    userName: 'User Name',
    groupNo: 'Group No.',
    groupName: 'Group Name',
    groupType: 'Group Type',
    grpproperty: 'Group Property',
    grpAttribute: 'Group Atribute',
    grpIdentity: 'Group Identity',
    impFileTypeErrTip: 'Import file is error',
    controlMember: 'Member Group Management',
    qryAdvance: 'Advanced Query',
    grptype0: 'Normal Group',
    grptype1: 'Roaming Group',
    grptype2: 'Hybrid Group',
    grptype3: 'Intersystem Group',
    grptype4: 'Grading group',
    grpproperty0: 'Static group',
    grpproperty1: 'Dynamic group',
    impugrpclass: 'Permissions within a user group',
    impugrppriority: 'Priority within user group',
    operSucess: 'Success',
    operObj: 'Operation Objects',
    operResult: 'Operation Results',
    loading: 'Loading ...',
    rtttype: 'User Type',
    rtttype1: 'Wireless Terminal',
    rtttype2: 'LDS',
    rtttype3: 'PoC Terminal',
    rtttype4: 'Dual-mode Terminal',
    rtttype5: 'Audio/Video Recording Server',
    rtttype6: 'Broadband Terminal',
    rtttype6_2: 'PNAS Terminal',
    rtttype8: 'Unified Location Provider',
    substatus0: 'ACTIVE',
    substatus1: 'STUN',
    substatus2: 'KILL',
    regstatus0: 'UNREGISTERED',
    regstatus1: 'REGISTERED',
    userenable: 'Enable Switch',
    userenable0: 'Disable',
    userenable1: 'Enable',
    noCheckDataTip: 'Please select one data',
    checkDataMoreTip: 'Only one data can be selected',
    checkDateLessTip: 'Select multiple data',
    notModWithDifTypeTip: 'Different types cannot be modified',
    checkVpnTip: 'Please select organization structure',
    loadingvpn: 'Loading VPN',
    vpnid: 'Organization Node',
    substatus: 'Sub Status',
    regstatus: 'Registration Status',
    createtime: 'Create Time',
    activetime: 'Active Time',
    resultReturnFailedTip: 'The result is wrong, please concat the adiministrator',
    staffId: 'Staff ID',
    staffName: 'Staff Name',
    licenseNum: 'License Plate Number',
    subNum: 'Subscriber Number',
    post: 'Post',
    profession: 'Profession',
    unitName: 'Unit Name',
    unitCode: 'Unit Code',
    mobile: 'Mobile',
    use: 'Use',
    terType: 'Terminal Type',
    temTitle: 'Subscriber/IMS Management/Template Management',
    infoTitle: 'Subscriber/IMS Management/Information Management',
    staffTitle: 'Staff Infomation',
    tempnum: 'Template Number',
    tempname: 'Template Name',
    temptype: 'Template Type',
    tempdate: 'Create Time',
    all: 'All',
    user: 'User',
    group: 'Group',
    noDialTip: 'No dialplan',
    endNOLessStartNo: 'End no should be greater than start no',
    sortBtn: 'Sort',
    unregister: 'UNREGISTERED',
    register: 'REGISTERED',
    userInfo: 'User Info',
    lsgxInfo: 'Member Config Info',
    dyGroupNotConfigLSGX: 'Dynamic group does not support adding membership',
    noDataCanOper: 'No data can operate',
    qryDataError: 'Device response data error',
    fuzzyQryNotApplSort: 'Fuzzy search does not support sorting',
    noSortVpn: 'No nodes need to be sorted',
    noOperatRole: 'The node does not have operation permission',
    userNumTitle: '*Subscriber Number:\r\n Subject to dialing scheme',
    grpNumTitle: '*GSI:\r\n Subject to dialing scheme',
    // grpNumTitle: '*组号码:\r\n符合拨号方案',
    dialogListSpan: 'Operation finished, success ',
    hour: 'h',
    minute: 'm',
    notFitDialPlan: 'Group number do not fit the dialplan rule',
    invalidInt: 'Invalid integer',
    grpnumrange: 'Group number should between 1~99999999',
    invalideChar: 'Invalid special Characters',
    maxlen15: 'Maximum 15 Characters allowed',
    exportdata: 'Export',
    importdata: 'Import',
    pleaseChoose: 'Please Choose',
    regClassNeeded: 'Please Choose at least one item in the RegClass',
    require: 'This field is required',
    charAt63: '8~63 characters are allowed',
    passwordRegex: '2 types of numbers,letters and special characters',
    charAt1To50: '{0}~{1} bytes are allowed',
    groupNumLimitTip: 'Support up to 1000 groups at a time.',
  },
  PDN: {
    nelist: 'NE List',
    pleaseSelectNE: 'Please Select The Network Element',
    crumb: 'Subscriber/LTE Management/PDN',
    add: 'Add',
    modify: 'Modify',
    remove: 'Delete',
    refresh: 'Refresh',
    pgwEnableLabel: 'User Contract PGW',
    pgwAddrLabel: 'PGW Address',
    pgwHostLabel: 'PGW Host',
    addProfile: 'Add Profile',
    modProfile: 'Modify Profile',
    confirm: 'Confirm',
    cancel: 'Cancel',
    success: 'Success',
    failed: 'Failed',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    doubleStack: 'Dual Stack',
    preemptable: 'ENABLED',
    preemptedable: 'ENABLED',
    noPreemptable: 'DISABLED',
    noPreemptedable: 'DISABLED',
    allowed: 'ALLOWED',
    unallowed: 'NOT_ALLOWED',
    addProfileSuccess: 'Add Profile Success',
    modProfileSuccess: 'Modify Profile Success',
    delProfileSuccess: 'Delete Profile Success',
    qryProfileSuccess: 'Query Profile Success',
    pleaseSelectDatas: 'Please Select Data',
    pleaseSelectOneData: 'Only One Data Can Be Choosed',
    profileId: 'PDN Profile ID',
    profileName: 'Profile Name',
    apnName: 'APN Name',
    pdnType: 'PDN Type',
    chargingCharacteristics: 'Charging Characteristics',
    apnAMBR_UL: 'APN AMBR UL(kbps)',
    apnAMBR_DL: 'APN AMBR DL(kbps)',
    vplmnAllowed: 'Access in Roaming Area',
    qci: 'QCI',
    arp0: 'PCI',
    arp2_5: 'PL',
    arp6: 'PVI',
    pgwIpv4Addr: 'PGW IPV4 Address',
    pgwIpv6Addr: 'PGW IPV6 Address',
    pgwHostName: 'PGW Host Name',
    pgwRealmName: 'PGW Realm',
    inquiry: 'Inquirty',
    delConfirm: 'Confirm to delete',
    selected: 'Have Chosen',
    item: 'Term',
    logger: 'Logger',
    required: 'This field is required',
    partofpdn: 'This value should belong to  Associated PDN Profile ID',
  },
  Profile: {
    nelist: 'NE List',
    pleaseSelectNE: 'Please choose ne',
    crumb: 'Subscriber/LTE Management/Subscriber signup template',
    add: 'Add',
    modify: 'Mod',
    remove: 'Delete',
    refresh: 'Refresh',
    addProfile: 'Add subscription profile',
    modProfile: 'Mod subscription profile',
    confirm: 'Confirm',
    cancel: 'Cancel',
    success: 'SUCCESS',
    failed: 'FAILED',
    addProfileSuccess: 'SUCCESS',
    modProfileSuccess: 'SUCCESS',
    delProfileSuccess: 'SUCCESS',
    qryProfileSuccess: 'SUCCESS',
    pleaseSelectDatas: 'Please choose data!',
    pleaseSelectOneData: 'Please choose one data!',
    profileId: 'Subscription Profile ID',
    RelatedProfile: 'Related Subscription Profile',
    profileName: 'Profile Name',
    ntwAccessMode: 'Network Access Mode',
    profileMaxUl: 'Max Uplink（UE-AMBR/Kbps）',
    profileMaxDl: 'Max Downlink（UE-AMBR/Kbps）',
    pdnProfileLst: 'Associated PDN Profile ID',
    dftPDNProfileID: 'Default PDN Profile ID',
    mccmncObj: 'MCC-MNC',
    chargingChars: 'UE Charging Characteristics',
    subsPeriodicRauTauTimer: 'Subs Periodic RAU/TAU Timer（s）',
    zonalCodeObj: 'Zonal Code',
    inquiry: 'Inquiry',
    delConfirm: 'Confirm to delete?',
    selected: 'selected',
    item: 'item',
    items: 'items',
    mccMncCode: 'MCC-MNC',
    zonalCode: 'Zonal Code',
    pdnProfileList: 'PDN Profile',
    pdnProfileId: 'Associated PDN Profile ID',
    pdnProfileName: 'PDN Profile Name',
    pdnApnName: 'APN Name',
    logger: 'Logger',
    maxadd:'At most',
    minadd:'At least',
    maxadd11:'At most 11 items',
    charAt32:'Please Enter 0-32 Characters',
    repeatMCCMNC: 'Duplicate PLMN',
    repeatCode: 'Duplicate zonal code',
  },
  LteUser: {
    nelist: 'Ne list',
    pleaseSelectNE: 'Please choose NE',
    crumb: 'Subscriber/LTE Management/Subscriber Management',
    imsiSearch: 'Input IMSI to search',
    add: 'Add',
    addBatch: 'Batch add',
    modify: 'Modify',
    remove: 'Delete',
    removeRange: 'Range Delete',
    refresh: 'Refresh',
    search: 'Search',
    addUser: 'Add user',
    addBatchUser: 'Batch add User',
    modUser: 'Modify User',
    delRange: 'Range Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    success: 'SUCCESS',
    failed: 'FAILED',
    addUserSuccess: 'SUCCESS',
    modUserSuccess: 'SUCCESS',
    delUserSuccess: 'SUCCESS',
    qryUserSuccess: 'SUCCESS',
    pleaseSelectDatas: 'Please select data!',
    pleaseSelectOneData: 'Please select one data!',
    imsi: 'IMSI',
    msisdn: 'MSISDN',
    profile_id: 'Subscription Profile ID',
    imsi_status: 'Subscription Status',
    imsi_odb: 'ODB',
    staticAddrCount: '静态地址个数',
    inquiry: 'Inquiry',
    delConfirm: 'Confirm to delete？',
    selected: 'selected',
    item: 'item',
    pdnProfileList: 'Associated PDN Profile',
    pdnProfileId: 'Associated PDN Profile ID',
    pdnType: 'PDN Type',
    pdnApnName: 'APN Name',
    staticAddr: 'Subscription Static IP Address',
    GRANTED: 'GRANTED',
    ODB: 'ODB',
    DISABLED: 'DISABLED',
    ipv4_addr: 'IPv4 Address',
    ipv6_addr: 'IPv6 Address',
    odb_0: 'Packet Oriented Service',
    odb_1: 'Roaming Access HPLMN-AP',
    odb_2: 'Roamer Access to VPLMN-AP',
    odb_3: 'Roamer Access',
    imsiRange: 'IMSI Range',
    character15: '15 characers',
    logger: 'Logger',
    staticAddrNum: 'Static IP Address Number',
    configStaticIP: 'Configure static IP address',
    wrong: 'Wrong',
    atleastone: 'At least 1',
    atmost: 'At most 10000',
    length15: 'Solid length 15',
    invalidnum: 'Invalid integer',
    imsireg:'Input integer that does not begin with zero.',
    batchAddUserTip: 'Batch add users',
    batchDelUserTip: 'Batch delete',
    exceedImsi:'Exists users whose IMSI exceed 15 characters',
    exceedMsisdn:'Exists users whose MSISDN exceed 11 characters',
    ipv4InfoCantEmpty: 'ipv4 cannot be empty',
  },
  TS: {
    trafficMeasurement: 'Traffic',
    callServiceStatistics: 'Call service statistics',
    callFailureCountStatistics: 'Call failure statistics',
    callSetUpTimeStatistics: 'Call setup time statistics',
    trafficTaskManagement: 'Task management',
    neName: 'Ne Name',
    neID: 'Ne ID',
    taskName: 'Task Name',
    taskDetail: 'Task Description',
    taskState: 'Task State',
    taskState_0: 'Stop',
    taskState_1: 'Excute',
    opTime: 'Operation Time',
    operation: 'Operation',
    starttime: 'Start Date',
    endtime: 'End Date',
    interval: 'Interval',
    startDateIsNull: 'Start date is required.',
    endDateIsNull: 'End date is required.',
    startDateGreaterEndDate: 'Start date cannot be later than end date.',
    neIDIsNull: 'Please Select Ne.',
    startDateEqualsEndDate: 'The start date and end date must be the same.',
    startDateNoEqualsEndDate: 'Start date and end date cannot be the same day.',
    startDateMaxEndDate: 'The interval must not exceed 31 days.',
    time15min: '15 min',
    time1hour: '1 hour',
    time1day: '1 day',
    alertMessage: 'Alert',
    singleCallSetUpTime: 'The number of times of single cycle call establishment time',
    configTime: 'Call establishment time range',
    configTimeRange: 'Call establishment time interval boundary value',
    ts_ok: 'OK',
    ts_cancell: 'Cancel',
    ts_search: 'Search',
    gs_search: 'Advanced search',
    callSetUpTimeCount: 'Count of set up time',
    callCount: 'Total Calls',
    callFailedCount: 'Failed Calls',
    singleCallFailedCount: 'Number of single cycle call failures',
    ts_chart_atleast_two_numbers: 'Enter at least two numbers.',
    ts_chart_illegal_number: 'The input must be digits',
    ts_chart_firstNumber_bigerthan0: 'Numbers must be larger than 0.',
    ts_chart_xAxis_positive_integer: 'Please enter a positive integer.',
    ts_number_not_null: 'The inputs must be consecutive.',
    ts_back_must_larger_than_pre: 'The latter value must be larger than the previous value.',
    ts_chart_single_call: 'Voice Private Call',
    ts_chart_group_call: 'Voice Group Call',
    ts_chart_single_video: 'Video Private Call',
    ts_chart_group_video: 'Video Group Call',
    ts_chart_broadcast_call: 'Broadcast Call',
    selectNeIDIsNull: 'Please select the NE in the search box first.',
    ts_task_oper_start: 'Start',
    ts_task_oper_stop: 'Stop',
    ts_call_task_name: 'Call Collection',
    ts_call_task_describer: 'Call Information Reporting',
    ts_reg_task_name: 'Reg Collection',
    ts_reg_task_describer: 'Reg Information Reporting',
    ts_xAxis: 'X-Axis',
    ts_neList: 'Ne List',
    ts_count: 'Count',
    ts_average_time: 'Average Time(ms)',
    ts_xAxis_time: 'Time',
    ts_call_type: 'Call Type',
    ts_call_setup_time: 'Set up time of single(ms)',
    ts_have_stop_task: 'Task is already stopped.',
    ts_have_start_task: 'Task is already started.',
    success: 'Success.',
    ts_cannot_operate: 'The operation cannot be performed.',
    ts_neOffLine: 'NE Offline.',
    ts_fail: 'The operation failed'
  },
  Spectrum: {
    ui_pt_taskstatus: 'Task Status',
    ui_pt_taskstatus_waiting: 'waiting...',
    ui_pt_taskstatus_submit: 'submitted',
    ui_pt_taskstatus_failed: 'failed',
    ui_pt_taskstatus_execute: 'executing...',
    ui_pt_taskstatus_stop: 'stopping...',
    ui_pt_taskstatus_end: 'end',
    ui_pt_starttime: 'Start Time',
    ui_pt_endtime: 'End Time',
    ui_pt_enodebid: 'eNodeB Id',
    ui_pt_cell: 'Cell Id',
    ui_pt_spectrumcycle: 'Cycle',
    ui_pt_spectrumstop: 'Stop',
    ui_pt_spectrumdelete: 'Delete',
    ui_pt_spectrumsectorid: 'Sector Id',
    ui_pt_spectrumphycellid: 'Phycell Id',
    ui_pt_spectrumseconds: ' seconds',
    ui_pt_spectrumstopped: 'Stopped',
    ui_pt_spectrumcantdelete: 'Cannot be deleted',
    ui_pt_spectrum1s: '1 s',
    ui_pt_spectrum2s: '2 s',
    ui_pt_spectrum5s: '5 s',
    ui_pt_spectrum10s: '10 s',
    ui_pt_spectrumchoose: 'Please choose eNodeB and Cell',
    ui_pt_spectrumbuild: 'Create spectrum scanning task',
    ui_pt_spectrumdelconform: 'Are you sure to delete?',
    ui_pt_spectrumsuspendre: 'Suspend refresh',
    ui_pt_spectrumpeakmon: 'Peak monitoring',
    ui_pt_spectrumavemon: 'Average monitoring',
    ui_pt_spectrumexpimg: 'Export image',
    ui_pt_neidorname: 'NE ID or name',
    ui_pt_spectrumlist: 'The list of spectrum scanning tasks',
    ui_pt_spectrumadd: 'Add',
    ui_pt_spectrumantdgm: 'Antenna interfere scanning diagram',
    ui_pt_spectrumfredgm: 'Frequency interfere scanning diagram',
    ui_pt_spectrumtimlin: 'Timeline',
    ui_pt_spectrumUnit: 'Unit：(Minute)',
    ui_pt_spectrumchfindex: 'Subframe Index',
    ui_pt_spectrummax: 'Max',
    ui_pt_spectrummin: 'Min',
    ui_pt_spectrumave: 'Average',
    ui_pt_spectrumsca: 'Spectrum scanning',
    400: 'You cannot delete the picture being used.',
    401: 'You cannot delete system default pictures.',
    402: 'The picture has already been deleted.',
    258: 'NEs already exist in this segment.',
    ui_pt_rbOption: 'RB Rssi(Unit：dBm)',
    ui_pt_spectrumDuration: 'Duration',
    ui_pt_spectrumunit: 'Unit',
    ui_pt_spectrumNoStop: 'No Stop',
    ui_pt_createtaskfailed: 'Failed to create spectrum task',
    ui_pt_stoptaskfailed: 'Failed to stop spectrum task',
    ui_pt_taskresperror: 'The response of spectrum task throw exeception, try again please!',
    ui_pt_command: 'Command',
    ui_pt_result: 'Result',
    ui_pt_taskrespnull: 'Spectrum result error!',

    6900: 'spectrum task exists now or the count of task is max, try again later!',
    6901: 'spectrum task does not exist or task is stop already!',
    6902: 'Can not delete in this state!',
    6903: 'Can not stop the finished task!',
    6906: 'The query task is full,Please wait!',
    6907: 'The response of spectrum exists exception, stop and try again please!',
    6908: 'Call stopSpectrumTask method invoke failed!',
    6909: 'Call removeSpectrumTask method invoke failed!',
    6910: 'Call selectSpectrumDatas method invoke failed!',
    6911: 'Call selectSpectrumDataByTime method invoke failed!',
    6912: 'Call selectSpectRecords method invoke failed!',
    ui_pt_spectrum1min: '1 minute',
    ui_pt_spectrum5min: '5 minutes',
    ui_pt_spectrum10min: '10 minutes',
    ui_pt_spectrum30min: '30 minutes',
    ui_pt_spectrum1hour: '1 hour',
    ui_pt_spectrum4hour: '4 hours',
    ui_pt_spectrum1day: '1 day',
    ui_pt_spectrum1week: '1 week',

    ui_pt_searchNe: ' Search Node:NeId/NeName',
    ui_pt_SpectrumTaskList: ' Spectrum Tasks List',
    ui_pt_spectrumtaskcreate: 'Create',
    ui_pt_removespectrumtask: 'Please select tasks!',
    NElist: 'Ne List',
    spectrum_manager: 'Spectrum Manager',
    ui_oper: 'Operation',
    ui_ok: 'OK',
    ui_cancell: 'Cancel',
    ui_cycle: 'Cycle:',
    ui_Duration: 'Duration:',
    ui_cell: 'Cell',
    ui_spectrumsectorid: 'Sector Id',
    ui_spectrumphycellid: 'Physical Cell Id'
  },
  UE: {
    ue_traffic: 'Up and down flow',
    ue_camera: 'Camera',
    ue_camera_name: 'Camera Name',
    ue_alias: 'UE Alias',
    ue_bs_id: 'BS ID',
    ue_bs_name: 'BS Alias',
    ue_ip: 'IP Address',
    ue_mac: 'Mac address',
    ue_ul_Traffic: 'Uplink traffic',
    ue_dl_Traffic: 'Downstream traffic',
    ue_ul_packet_rate: 'Uplink packet rate',
    ue_dl_packet_rate: 'Downlink rate',
    neList: 'Ne List',
    ueTraffic: 'UE traffic',
    ueCancell: 'Cancel',
    ueConfirm: 'Confirm',
    ueDetailData: 'Detailed data',
    ueSelectDatas: 'Please select data !',
    ueSelectOneData: 'Please select a piece of data.',
    ueSearch: 'select',
    ueManager: 'UE Manager',
    ueShowMap: 'UE Map',
    ue_rsrp1: 'Serving Cell RSRP1',
    ue_rsnp2: 'Serving Cell RSRP2',
    ue_nrsrp1: 'Adjacent Region RSRP1',
    ue_nrsnp2: 'Adjacent Region RSRP2',
    ue_sinr1: 'SINR1',
    ue_sinr2: 'SINR2',
    ue_ul_data: 'Upstream traffic',
    ue_dl_data: 'Downstream traffic',
    ue_selected: 'Selected UE',
    ue_search_imsi: 'Search IMSI',
    ue_imsi: 'IMSI',
    ue_base_enodeb: 'Belongs BS Alias',
    ue_state: 'UE State',
    ue_state_off: 'Offline',
    ue_state_up: 'Online',
    ue_state_idle: 'Idle',
    select_ue_data:'Please select UE',
    select_ue:'Select UE',
    bs_online_count: 'BS Online Count: ',
    ue_online_count: 'UE Online Count: ',
    ue_select_limit: 'Selected UE maximum is 5',
    legend_bs:'Base Station',
    legend_ue:'Terminal',
    legend:'Legend',
    latLng: 'LatLng',
    ue_chart: 'SubscribeUeChart',
    pleaseSelectNe: 'Please select network element node'
  },
  DataManagent: {
    neid: 'Neid',
    clientIp: 'clientIp',
    distIp: 'distIp',
    systemUser: 'systemUser',
    opTime: 'opTime',
    neVersion: 'neVersion',
    opType: 'opType',
    opResult: 'opResult',
    createDataFileFail: 'Data file created failed',
    requestTimeOut: 'Time Out',
    export: 'Export',
    import: 'Import',
    chooseDataTip: 'Please Choose Data',
    chooseNeidTip: 'Please Choose Ne',
    success: 'Succeeded',
    fail: 'Failure',
    crumb: 'Subscriber/Data Managment',
  },
  DNN: {
    crumb: '开户管理/udm管理/DNN模板',
    profileId: 'DNN模板ID',
    profileName: '模板名称',
    dnnName: '接入点名称',
    ambrUp: 'DNN上行AMBR(kbps)',
    ambrDown: 'DNN下行AMBR(kbps)',
    chargeChars: '计费特性',
    pduSessionType: 'PDU会话类型',
    dftPduSessionType: '默认PDU会话类型',
    sscMode: 'SSC模式',
    dftSscMode: '默认SSC模式',
    fiveQi: '5QI',
    fiveQiPriorityLevel: '5QI优先级',
    pl: 'ARP优先级',
    pev: 'ARP可被强占',
    pec: 'ARP可抢占',
    pduType0: 'IPv4',
    pduType1: 'IPv6',
    pduType2: 'IPV4V6',
    pduType3: 'TRUCTURED',
    pduType4: 'ETHERNET',
    sscMode0: 'SSC_MODE_1',
    sscMode1: 'SSC_MODE_2',
    sscMode2: 'SSC_MODE_3',
    addProfileSuccess: '添加DNN模板成功',
    modProfileSuccess: '修改DNN模板成功',
    delProfileSuccess: '删除DNN模板成功',
    qryProfileSuccess: '查询DNN模板成功',
    dnnParamInfo: 'DNN参数',
    pduSessionParamInfo: 'PDU会话参数',
    sscModeParamInfo: 'SSC模式参数',
    qosParamInfo: 'Qos参数',
    enabled: '可被抢占',
    disabled: '不可被抢占',
    enabledPec: '可抢占',
    disabledPec: '不可抢占',
  },
  Snssai: {
    crumb: '开户管理/udm管理/网络切片模板',
    addProfile: '新增网络切片模板',
    modProfile: '修改网络切片模板',
    addProfileSuccess: '添加网络切片模板成功',
    modProfileSuccess: '修改网络切片模板成功',
    delProfileSuccess: '删除网络切片模板成功',
    qryProfileSuccess: '查询网络切片模板成功',
    dnnProfileList: 'DNN模板',
    sst: 'SST',
    sd: 'SD',
    profileId: '网络切片模板ID',
    profileName: '模板名称',
    dnnProfile: '关联DNN模板ID',
    dnnProfileName: 'DNN名称',
  },
  AmData: {
    crumb: '开户管理/udm管理/AM-DATA模板',
    addProfile: '新增AM-DATA模板',
    modProfile: '修改AM-DATA模板',
    addProfileSuccess: '添加AM-DATA模板成功',
    modProfileSuccess: '修改AM-DATA模板成功',
    delProfileSuccess: '删除AM-DATA模板成功',
    qryProfileSuccess: '查询AM-DATA模板成功',
    ueAmbrUp: '最大上行带宽(UE-AMBR/Kbps)',
    ueAmbrDown: '最大下行带宽(UE-AMBR/Kbps)',
    profileId: 'AM-DATA模板ID',
    profileName: '模板名称',
  },
  Plmn: {
    crumb: '开户管理/udm管理/PLMN模板',
    addProfile: '新增PLMN模板',
    modProfile: '修改PLMN模板',
    addProfileSuccess: '添加PLMN模板成功',
    modProfileSuccess: '修改PLMN模板成功',
    delProfileSuccess: '删除PLMN模板成功',
    qryProfileSuccess: '查询PLMN模板成功',
    mcc: '国家码',
    mnc: '网络码',
    amDataProfileIds: '关联AM-DATA模板',
    snssaiProfileIds: '关联网络切片模板',
    amDataProfile: 'AM-DATA模板',
    snssaiProfile: '网络切片模板',
    profileId: 'PLMN模板ID',
    profileName: '模板名称',
    amDataProfileId: '关联AM-DATA模板ID',
    amDataProfileName: 'AM-DATA模板名称',
    snssaiProfileId: '关联网络切片模板ID',
    snssaiProfileName: '网络切片模板名称',
  },
  Usersub: {
    crumb: '开户管理/udm管理/用户签约模板',
    profileId: '用户签约模板ID',
    profileName: '模板名称',
    plmnInfos: 'PLMN',
    addProfile: '新增用户签约模板',
    modProfile: '修改用户签约模板',
    addProfileSuccess: '添加用户签约模板成功',
    modProfileSuccess: '修改用户签约模板成功',
    delProfileSuccess: '删除用户签约模板成功',
    qryProfileSuccess: '查询用户签约模板成功',
    plmnProfileId: '关联PLMN模板ID',
    plmnProfileName: 'PLMN模板名称',
    plmnProfileIds: '关联PLMN模板',
  },
  Supi: {
    crumb: '开户管理/udm管理/用户管理',
    supiSearch: '输入SUPI号进行查询',
    supi: 'SUPI',
    gpsi: 'GPSI',
    userSubProfileId: '关联用户签约模板',
    ipv4Addr: '静态IPV4地址',
    ipv6Addr: '静态IPV6地址',
    supiRange: 'SUPI范围',
  }
};
